<template>
  <section class="colors">
    <img :src="carImage(colorsData.key, currentColor.image)" :alt="colorsData.key" class="colors__img">
    
    <div class="colors__list">
      <div
        v-for="(color, i) in colorsData.colors"
        :key="`color-${i}`"
        class="colors__list--item item"
        :class="{ 'item__active': color.color === currentColor.color }"
        @click="toggleColor(color)"
      >
        <div class="item__color" :style="{ backgroundColor: color.color }"></div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "colors",
  props: ["colorsData"],
  data() {
    return {
      currentColor: this.colorsData.colors[0],
    };
  },
  computed: {
    carImage: () => (name, color) => {
      try {
        return require(`../../../images/cars/${name}/${color}.webp`);
      } catch {
        return require(`../../../images/cars/${name}/${color}.png`);
      }
    },
  },
  methods: {
    toggleColor(color) {
      this.currentColor = color;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/constants.scss";

.colors {
  display: flex;
  position: relative;
  margin-top: auto;
  margin-left: auto;
  max-width: 41em;
  
  &__img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  &__list {
    position: absolute;
    top: 1em;
    right: 0.5em;
    display: flex;
    flex-direction: column;
    gap: 0.8em;
    height: max-content;
    border: 1px solid #4C4C4C66;
    background: #FFFFFF29;
    backdrop-filter: blur(5px);
    border-radius: 2.65em;
    padding: 0.8em 0.2em;
  }

  .item {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 1.9em;
    height: 1.9em;
    border-radius: 50%;
    border: 1px solid transparent;
    cursor: pointer;
    transition: all 0.3s;

    &__active {
      border: 1px solid #DDDDDD;
    }

    &__color {
      width: 1.4em;
      height: 1.4em;
      border-radius: inherit;
    }
  }
}

@media (max-width: 800px) {
  .colors {
    flex-direction: column;
    align-items: center;
    width: 100%;
    
    &__img {
      max-width: 100%;
    }

    &__list {
      position: static;
      flex-direction: row;
      background: transparent;
    }

    .item {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 3.8em;
      height: 3.8em;
      border-radius: 50%;
      border: 1px solid transparent;
      cursor: pointer;
      transition: all 0.3s;

      &__active {
        border: 1px solid #DDDDDD;
      }

      &__color {
        width: 2.8em;
        height: 2.8em;
        border-radius: inherit;
      }
    }
  }
}
</style>
